<app-modal-container>
  <header header>
    <!-- 헤더 (고정) -->
    <div class="shrink-0 flex w-full justify-between items-center border-b border-zinc-100 p-4">
      <h3 class="text-lg font-semibold text-zinc-800">{{ policyTitle() }}</h3>
      <button (click)="close()" class="cursor-pointer flex items-center">
        <app-icon name="material-symbols:close" class="size-5! text-zinc-400" />
      </button>
    </div>
  </header>

  <!-- 컨텐츠 (스크롤 영역) -->
  <div class="flex-1 w-full p-4 lg:max-w-sm">
    @if ($term.value(); as term) {
    <div class="prose max-w-none text-sm" [innerHTML]="term | safeHtml"></div>
    } @else {
    <app-not-found [isLoading]="$term.isLoading()">
      <p class="text-gray-500">약관 내용이 없습니다.</p>
    </app-not-found>
    }
  </div>

  <!-- 푸터 (고정) -->
  <footer footer class="shrink-0 w-full pt-4 border-t border-zinc-100 p-4">
    <button
      (click)="close(true)"
      class="cursor-pointer w-full bg-primary-500 text-white font-medium py-3 px-4 rounded-xl">
      확인
    </button>
  </footer>
</app-modal-container>
